export default __webpack_public_path__ + "static/media/minio-kapak.6ca40d49.jpg";